import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Button,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from 'react-toastify';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} style={{ left: 8 }}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text || '');
    toast.success('تم النسخ');
  } catch (e) {
    toast.error('تعذر النسخ');
  }
};

const OwnerCredentialsModal = ({ isOpen, onClose, owner }) => {
  const ownerName = owner?.name ?? '';
  const ownerPassword = owner?.password ?? '';

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="owner-credentials-dialog-title"
      open={isOpen}
      style={{ maxHeight: 600, direction: 'rtl' }}
      className="add-driver-modal"
    >
      <DialogTitle id="owner-credentials-dialog-title" onClose={onClose}>
        بيانات الدخول
      </DialogTitle>
      <DialogContent dividers>
        <form className="form">
          <div className="input-wrapper">
            <label className="input-label">اسم المستخدم</label>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #ced4da',
                borderRadius: 4,
                padding: '6px 8px',
                minHeight: 36,
              }}
            >
              <div
                onClick={() => copyToClipboard(ownerName)}
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: '#006782',
                  width: '100%',
                }}
                title="انسخ اسم المستخدم"
              >
                {ownerName}
              </div>
            </div>
          </div>

          <div className="input-wrapper">
            <label className="input-label">كلمة المرور</label>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #ced4da',
                borderRadius: 4,
                padding: '6px 8px',
                minHeight: 36,
              }}
            >
              <div
                onClick={() => copyToClipboard(ownerPassword)}
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: '#006782',
                  width: '100%',
                }}
                title="انسخ كلمة المرور"
              >
                {ownerPassword}
              </div>
            </div>
          </div>
        </form>
      </DialogContent>
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 24px' }}>
        <Button style={{ backgroundColor: '#006782', color: 'white' }} variant="contained" onClick={onClose}>اغلاق</Button>
      </div>
    </Dialog>
  );
};

export default OwnerCredentialsModal;


